/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type VersionResponse = {
  version?: string;
};

export default function getVersion({
  token,
}: {
  token: string;
}): Promise<InternalResponse<VersionResponse>> {
  return request()({
    url: "/xecguard/v1/internal/version",
    method: "GET",
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<VersionResponse>): InternalResponse<VersionResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
